import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import App from "../App";
import Login from "../Login";

import { observer, inject } from "mobx-react";
@inject("commonStore")
@observer
class RouterAuth extends Component {

  render() {
    const { isLoggedIn } = this.props.commonStore;
    return (
      <Router>
        <Switch>
          <Route path="/logout" component={Login} />
          <Route path="/login" component={Login} />
          <Route path="/" render={() => (isLoggedIn ? <App /> : <Redirect to="/login" />)} />
        </Switch>
      </Router>
    );
  }
}

export default RouterAuth;



// WEBPACK FOOTER //
// ./src/components/RouterAuth/RouterAuth.js